"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTimeoutSignal = void 0;
const NOOP = () => undefined;
const createTimeoutSignal = (ms) => {
    try {
        if (typeof AbortSignal !== 'undefined' &&
            typeof AbortSignal.timeout === 'function') {
            return { signal: AbortSignal.timeout(ms), cancel: NOOP };
        }
        if (typeof AbortController === 'undefined') {
            return { signal: undefined, cancel: NOOP };
        }
        const controller = new AbortController();
        const timer = setTimeout(() => controller.abort(), ms);
        return {
            signal: controller.signal,
            cancel: () => clearTimeout(timer),
        };
    }
    catch {
        // Never let timeout plumbing be the thing that drops an event.
        return { signal: undefined, cancel: NOOP };
    }
};
exports.createTimeoutSignal = createTimeoutSignal;
